import PropTypes from 'prop-types'

import AtomSpinner, {atomSpinnerOverlayTypes, atomSpinnerSizes, atomSpinnerTypes} from '@s-ui/react-atom-spinner'

import CustomSpinnerBasicLoader from './CustomSpinnerBasicLoader.js'

const SpinnerBasic = ({
  inheritColorText = false,
  overlayType = atomSpinnerOverlayTypes.DARK,
  size = atomSpinnerSizes.MEDIUM,
  text,
  type = atomSpinnerTypes.FULL
}) => {
  return (
    <AtomSpinner overlayType={overlayType} size={size} type={type}>
      <CustomSpinnerBasicLoader inheritColorText={inheritColorText} text={text} />
    </AtomSpinner>
  )
}

SpinnerBasic.propTypes = {
  inheritColorText: PropTypes.bool,
  overlayType: PropTypes.oneOf(Object.values(atomSpinnerOverlayTypes)),
  size: PropTypes.string,
  text: PropTypes.string,
  type: PropTypes.oneOf(Object.values(atomSpinnerTypes))
}
SpinnerBasic.displayName = 'SpinnerBasic'

export {
  atomSpinnerOverlayTypes as spinnerBasicOverlayTypes,
  atomSpinnerSizes as spinnerBasicSizes,
  atomSpinnerTypes as spinnerBasicTypes
}

export default SpinnerBasic
